import PCRTable from './PCRTable';
export default PCRTable;
